const fundwiseOutstandingHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	co_id: "CO ID",
	co_name: "CO Name",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	prn_disb_amt: "Principal Disbursement Amount",
	prn_outstanding: "Outstanding Principal",
	intt_outstanding: "Outstanding Interest",
	penal_amount: "Penal Amount",
	outstanding: "Total Outstanding",
}

const cowiseOutstandingHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	prn_disb_amt: "Principal Disbursement Amount",
	prn_outstanding: "Outstanding Principal",
	intt_outstanding: "Outstanding Interest",
	penal_amount: "Penal Amount",
	outstanding: "Total Outstanding",
	co_name: "CO Name",
}

const memberwiseOutstandingHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	loan_id: "Loan ID",
	form_no: "Form Number",
	member_code: "Member Code",
	client_name: "Client Name",
	client_mobile: "Client Mobile",
	dob: "Date of Birth",
	age: "Age",
	gurd_name: "Guardian Name",
	husband_name: "Husband's Name",
	client_addr: "Client Address",
	voter_id: "Voter ID",
	pan_no: "PAN Number",
	aadhar_no: "Aadhar Number",
	nominee_name: "Nominee Name",
	group_code: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	acc_no1: "Account No 1",
	acc_no2: "Account No 2",
	co_name: "CO Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	purpose: "Loan Purpose",
	purpose_id: "Purpose ID",
	applied_dt: "Applied Date",
	applied_amt: "Applied Amount",
	loan_date: "Loan Date",
	loan_amount: "Loan Amount",
	curr_roi: "Current ROI",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	prn_outstanding: "Outstanding Principal",
	intt_outstanding: "Outstanding Interest",
	penal_amount: "Penal Amount",
	outstanding: "Total Outstanding",
}

const groupwiseOutstandingHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	acc_no1: "Account No 1",
	acc_no2: "Account No 2",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	prn_disb_amt: "Principal Disbursement Amount",
	prn_outstanding: "Outstanding Principal",
	intt_outstanding: "Outstanding Interest",
	penal_amount: "Penal Amount",
	outstanding: "Total Outstanding",
	co_name: "CO Name",
}

const disbursementDetailsHeader = {
	loan_id: "Loan ID",
	member_code: "Member Code",
	client_name: "Client Name",
	purpose: "Purpose",
	purpose_id: "Purpose Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	curr_roi: "Current ROI",
	period: "Period",
	period_mode: "Period Mode",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	applied_amt: "Applied Amt",
	disb_dt: "Disburse Date",
	disburse_amt: "Disburse Amt",
	tot_emi: "Total EMI",
	// week_no: "Recovery Day",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	curr_outstanding: "Current Outstanding",
	loan_cycle: "Loan Cycle",
	penal_intt: "Penal Amount"
}

const branchwiseOutstandingHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	prn_disb_amt: "Disbursement Amt",
	prn_outstanding: "Outstanding Principal",
	intt_outstanding: "Outstanding Interest",
	penal_amount: "Penal Amount",
	outstanding: "Outstanding",
}

const groupwiseDemandVsCollectionHeader = {
	demand_date: "Demand Date",
	"collec between": "Collection Between",
	payment_date: "Payment Date",
	bank_name: "Bank Name",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	group_code: "Group Code",
	group_name: "Group Name",

	co_id: "CO ID",
	co_name: "CO Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	curr_roi: "Current ROI",
	loan_period: "Loan Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	instl_start_dt: "Installment Start Date",
	instl_end_dt: "Loan End Date",
	tot_emi: "Total EMI",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	demand_amt: "Demand Amount",
	// demand_after_collection: "Demand After Collection",
	curr_outstanding: "Current Outstanding",
}

const groupwiseDemandVsCollectionHeader_New = {
	demand_date: "Demand Date",
	"collec between": "Collection Between",
	payment_date: "Payment Date",
	bank_name: "Bank Name",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	group_cd: "Group Code",
	group_name: "Group Name",

	co_id: "CO ID",
	// emp_name: "Employee Name",
	co_name: "CO Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	curr_roi: "Current ROI",
	loan_period: "Loan Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	instl_start_dt: "Installment Start Date",
	instl_end_dt: "Loan End Date",
	tot_emi: "Total EMI",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	demand_amt: "Demand Amount",
	// demand_after_collection: "Demand After Collection",
	curr_outstanding: "Current Outstanding",
}

const cowiseDemandVsCollectionHeader = {
	demand_date: "Demand Date",
	payment_date: "Payment Date",
	collec_upto: "Collection Upto",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_cd: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	total_group: "Total Group",
	total_member: "Total Member",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	tot_emi: "Total EMI",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	// demand_after_collection: "Demand After Collection",
	demand_amt: "Demand Amount",
	curr_outstanding: "Current Outstanding",
}

const memberwiseDemandVsCollectionHeader = {
	demand_date: "Demand Date",
	"collec between": "Collection Between",
	payment_date: "Payment Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	loan_id: "Loan ID",
	member_code: "Member Code",
	client_name: "Client Name",
	client_mobile: "Client Mobile",
	group_code: "Group Code",
	group_name: "Group Name",
	bank_name: "Bank Name",
	bank_branch_name: "Branch Name",
	// bank_branch_name: "Branch Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	emp_name: "CO Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	created_code: "Created Branch Code",
	created_at: "Created At",
	created_by: "Created By",
	approved_code: "Approved Branch Code",
	approved_by: "Approved By",
	approved_at: "Approved At",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	curr_roi: "Current ROI",
	loan_period: "Loan Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	week_no: "Week of Recovery",
	instl_start_dt: "Installment Start Date",
	instl_end_dt: "Loan End Date",
	tot_emi: "Total EMI",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	// demand_after_collection: "Demand After Collection",
	demand_amt: "Demand Amount",
	curr_outstanding: "Current Outstanding",
}

const branchwiseDemandVsCollectionHeader = {
	demand_date: "Demand Date",
	"collec between": "Collection Between",
	branch_id: "Branch ID",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	tot_emi: "Total EMI",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	// demand_after_collection: "Demand After Collection",
	demand_amt: "Demand Amount",

	curr_outstanding: "Current Outstanding",
}

const fundwiseDemandVsCollectionHeader = {
	demand_date: "Demand Date",
	payment_date: "Payment Date",
	collec_upto: "Collection Upto",
	branch_code: "Branch Code",

	group_cd: "Group Code",
	group_name: "Group Name",
	bank_name: "Bank Name",
	branch_name: "Branch Name",
	area_code: "Division Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_name: "CO Name",
	co_id: "CO ID",
	// emp_name: "CO Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	credit: "Credit Amount",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	curr_balance: "Current Balance",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	coll_amt: "Collection Amount",
	penal_amount: "Penal Amount",
	demand_amt: "Demand Amount",
	curr_outstanding: "Current Outstanding",
}

const groupwiseDemandReportHeader = {
	demand_date: "Demand Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	prn_disb_amt: "Principal Disbursement Amount",
	curr_roi: "Current ROI",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	instl_end_dt: "Demand End Date",
	dmd_amt: "Demand Amount",
	penal_amt: "Penal Amount",
	outstanding: "Outstanding",

}

const fundwiseDemandReportHeader = {
	demand_date: "Demand Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	groupcd: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	dmd_amt: "Demand Amount",
	penal_amt: "Penal Amount",
	curr_outstanding: "Current Outstanding",
}

const cowiseDemandReportHeader = {
	demand_date: "Demand Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	groupcd: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	dmd_amt: "Demand Amount",
	penal_amt: "Penal Amount",
	curr_outstanding: "Current Outstanding",
}

const memberwiseDemandReportHeader = {
	demand_date: "Demand Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	loan_id: "Loan ID",
	member_code: "Member Code",
	client_name: "Client Name",
	groupcd: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	curr_roi: "Current ROI",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	instl_end_dt: "Demand End Date",
	tot_emi: "Total EMI",
	demand_amt: "Demand Amount",
	penal_amt: "Penal Amount",
	curr_outstanding: "Current Outstanding",
}

const branchwiseDemandReportHeader = {
	demand_date: "Demand Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	demand_amt: "Demand Amount",
	penal_amt: "Penal Amount",
	curr_outstanding: "Current Outstanding",
}

const overdueGroupReportHeader = {
	trf_date: "Report Date",
	first_od_date: "First Overdue Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	acc_no1: "Savings Account",
	acc_no2: "Loan Account",
	bank_addr: "Bank Address",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	code: "Code",
	co_name: "CO Name",
	loan_amt: "Loan Amount",
	instl_end_dt: "Installment End Date",
	outstanding_principal: "Outstanding Principal",
	outstanding_interest: "Outstanding Interest",
	total_outstanding: "Total Outstanding",
	overdue: "Overdue Amount",
	penal_amount: "Penal Amount",
	Category: "Category",
	remarks: "Remarks"
}

const overdueFundReportHeader = {
	trf_date: "Report Date",
	first_od_date: "First Overdue Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	code: "Code",
	co_name: "CO Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	loan_amt: "Loan Amount",
	instl_end_dt: "Installment End Date",
	outstanding_principal: "Outstanding Principal",
	outstanding_interest: "Outstanding Interest",
	total_outstanding: "Total Outstanding",
	overdue: "Overdue Amount",
	penal_amount: "Penal Amount",
	Category: "Category"
}

const overdueCOReportHeader = {
	trf_date: "Report Date",
	first_od_date: "First Overdue Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	code: "Code",
	co_name: "CO Name",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	loan_amt: "Loan Amount",
	instl_end_dt: "Installment End Date",
	outstanding_principal: "Outstanding Principal",
	outstanding_interest: "Outstanding Interest",
	total_outstanding: "Total Outstanding",
	overdue: "Overdue Amount",
	penal_amount: "Penal Amount",
	Category: "Category"
}

const overdueMemberReportHeader = {
	trf_date: "Report Date",
	first_od_date: "First Overdue Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	acc_no1: "Savings Account",
	acc_no2: "Loan Account",
	bank_address: "Bank Address",
	period: "Period",
	period_mode: "Period Mode",
	recovery_day: "Recovery Day",
	week_no: "Week of Recovery",
	member_code: "Member Code",
	client_name: "Client Name",
	client_mobile: "Client Mobile",
	gurd_name: "Guarantor Name",
	code: "Code",
	co_name: "CO Name",
	scheme_name: "Scheme Name",
	loan_id: "Loan ID",
	loan_date: "Loan Date",
	loan_amt: "Loan Amount",
	instl_end_dt: "Installment End Date",
	outstanding_principal: "Outstanding Principal",
	outstanding_interest: "Outstanding Interest",
	total_outstanding: "Total Outstanding",
	overdue: "Overdue Amount",
	penal_amount: "Penal Amount",
	last_payment: "Last Payment Date",
	od_days: "Overdue Days",
	Category: "Category"
}

const overdueBranchReportHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	outstanding_principal: "Outstanding Principal",
	outstanding_interest: "Outstanding Interest",
	loan_amt: "Loan Amount",
	total_outstanding: "Total Outstanding",
	overdue: "Overdue Amount",
	penal_amount: "Penal Amount",
	Category: "Category"
}


const Receipt_Summary_Report_Group = {
	payment_date: "Payment Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name",
	no_of_receipts: "No Of Receipts",
	payment_ids: "Receipts No."
}

const Receipt_Summary_Report_CO = {
	payment_date: "Payment Date",
	branch_code: "Branch Code",
	co_id: "Co-ID",
	emp_name: "Employee Name",
	branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name",
	no_of_receipts: "No Of Receipts",
	payment_ids: "Receipts No."
}

const Receipt_Summary_Report_Group_Branch = {
	payment_date: "Payment Date",
	// branch_code: "Branch Code",
	// branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name",
	no_of_receipts: "No Of Receipts",
	payment_ids: "Receipts No."
}

const Receipt_Summary_Report_CO_Branch = {
	payment_date: "Payment Date",
	// branch_code: "Branch Code",
	co_id: "Co-ID",
	emp_name: "Employee Name",
	// branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name",
	no_of_receipts: "No Of Receipts",
	payment_ids: "Receipts No."
}

const COwise_Collection_Summary_Report = {
    co_name: "CO ID & Name",
    group_name_code: "Group Name & Code",
    total_collect_amount: "Total Collection Amount",
    cash_amount: "Cash Amount",
    upi_amount: "UPI Amount"
}

const COwise_Collection_Summary_Report_HO = {
    co_name: "CO ID & Name",
    branch_name: "Branch Name & Code",
    group_name_code: "Group Name & Code",
    total_collect_amount: "Total Collection Amount",
    cash_amount: "Cash Amount",
    upi_amount: "UPI Amount"
}


// {
//   "payment_date": "28/04/2026",
//   "branch_code": 111,  ////
//   "branch_name": "Baruipur(TOTAL BC)", //// 
//   "group_code": 10569, ////
//   "group_name": "Sarat-1", ////
//   "no_of_receipts": 5,
//   "payment_ids": "1778663544196,1778663544257,1778663544284,1778663544318,1778663544347"
// }


const memberwiseReportHeader = {
	form_no: "Form No",
	grt_date: "GRT Date",
	member_code: "Member Code",
	client_name: "Client Name",
	group_code: "Group Code",
	group_name: "Group Name",
	area_code: "Division Name",
	group_open_date: "Group Open Date",
	closed_dt: "Group Close Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	client_mobile: "Mobile",
	gurd_name: "Gurdian Name",
	gurd_mobile: "Gurdian Mobile",
	husband_name: "Husband Name",
	client_addr: "Client Address",
	pin_no: "PIN No.",
	nominee_name: "Nominee Name",
	aadhar_no: "Aadhar No",
	pan_no: "PAN No",
	voter_id: "Voter ID",
	religion: "Religion",
	caste: "Caste",
	education: "Education",
	dob: "DOB",
	co_name: "CO Name",
	co_id: "CO ID",
	phone1: "Phone 1",
	phone2: "Phone 2",
	grp_addr: "Group Address",
	dist_name: "District",
	block_name: "Block",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	ifsc: "IFSC",
	micr: "MICR",
	savings_acc: "Savings Account",
	loan_acc: "Loan Account",
	self_occu: "Self Occupation",
	self_income: "Self Income",
	spouse_occu: "Spouse Occupation",
	spouse_income: "Spouse Income",
	loan_purpose: "Loan Purpose",
	applied_amt: "Applied Amount",
	other_loan_amt: "Other Loan Amount",
	other_loan_emi: "Other Loan EMI",
	other_loan_flag: "Other Loan",
	house_type: "House Type",
	own_rent: "Own Rent",
	parental_addr: "Parental Address",
	parental_phone: "Parental Phone"
}

const memberwiseReportHeader_No_CloseDate = {
	form_no: "Form No",
	grt_date: "GRT Date",
	member_code: "Member Code",
	client_name: "Client Name",
	group_code: "Group Code",
	group_name: "Group Name",
	area_code: "Division Name",
	group_open_date: "Group Open Date",
	//   closed_dt: "Group Close Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	client_mobile: "Mobile",
	gurd_name: "Gurdian Name",
	gurd_mobile: "Gurdian Mobile",
	husband_name: "Husband Name",
	client_addr: "Client Address",
	pin_no: "PIN No.",
	nominee_name: "Nominee Name",
	aadhar_no: "Aadhar No",
	pan_no: "PAN No",
	voter_id: "Voter ID",
	religion: "Religion",
	caste: "Caste",
	education: "Education",
	dob: "DOB",
	co_name: "CO Name",
	co_id: "CO ID",
	phone1: "Phone 1",
	phone2: "Phone 2",
	grp_addr: "Group Address",
	dist_name: "District",
	block_name: "Block",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	ifsc: "IFSC",
	micr: "MICR",
	savings_acc: "Savings Account",
	loan_acc: "Loan Account",
	self_occu: "Self Occupation",
	self_income: "Self Income",
	spouse_occu: "Spouse Occupation",
	spouse_income: "Spouse Income",
	loan_purpose: "Loan Purpose",
	applied_amt: "Applied Amount",
	other_loan_amt: "Other Loan Amount",
	other_loan_emi: "Other Loan EMI",
	other_loan_flag: "Other Loan",
	house_type: "House Type",
	own_rent: "Own Rent",
	parental_addr: "Parental Address",
	parental_phone: "Parental Phone"
}

const groupReportGroupWiseHeader = {
	group_code: "Group Code",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	group_name: "Group Name",
	area_code: "Division Name",
	group_open_date: "Group Open Date",
	closed_dt: "Group Close Date",
	co_name: "CO Name",
	co_id: "CO ID",
	phone1: "Mobile 1",
	phone2: "Mobile 2",
	grp_addr: "Group Address",
	dist_name: "District",
	block_name: "Block",
	pin_no: "PIN No.",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	ifsc: "IFSC",
	micr: "MICR",
	savings_acc: "Savings Account",
	loan_acc: "Loan Account"
}

const groupReportGroupWiseHeader_No_CloseDate = {
	group_code: "Group Code",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	group_name: "Group Name",
	area_code: "Division Name",
	group_open_date: "Group Open Date",
	//   closed_dt: "Group Close Date",
	co_name: "CO Name",
	co_id: "CO ID",
	phone1: "Mobile 1",
	phone2: "Mobile 2",
	grp_addr: "Group Address",
	dist_name: "District",
	block_name: "Block",
	pin_no: "PIN No.",
	bank_name: "Bank Name",
	bank_branch: "Bank Branch",
	ifsc: "IFSC",
	micr: "MICR",
	savings_acc: "Savings Account",
	loan_acc: "Loan Account"
}

const transactionFieldNames = {
	transaction_date: "Transaction Date",
	transaction_id: "Transaction ID",
	branch_id: "Branch ID",
	branch_code: "Branch ID",
	branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name",
	loan_id: "Loan ID",
	tr_type: "Transaction Type",
	debit: "Debit",
	credit: "Credit",
	penal_recov: "Penal",
	created_code: "Created Branch Code",
	created_by: "Created By",
}
const rejectTransFieldNames = {
	transaction_date: "Transaction Date",
	transaction_id: "Transaction ID",
	branch_name: "Branch Name & ID",
	group_name: "Group Name & code",
	loan_id: "Loan ID",
	member_name: "Member Name",
	credit: "Credit",
	penal_recov: "Penal Recovery",
	created_by: "Created By",
	requisitioned_by: "Requisitioned By",
	granted_by: "Granted By",
}

const searchRejectTransFieldNames = {
	payment_date: "Transaction Date",
	payment_id: "Transaction ID",
	branch_name: "Branch Name",
	group_code: "Group Code",
	group_name: "Group Name & Code",
	loan_id: "Loan ID",
	member_code: "Member Code",
	client_name: "Member Name",
	credit: "Credit",
	reject_remarks: "Reject Remarks",
	created_code: "Created Branch Code",
	created_by: "Created By",
	created_at: "Created At",
	rejected_code: "Rejected Branch Code",
	rejected_by: "Rejected By",
	rejected_at: "Rejected At"
}

const requestedRequisitionHeader = {
	payment_date: "Payment Date",
	payment_id: "Payment ID",
	branch_id: "Branch ID",
	group_code: "Group Code",
	branch_name: "Branch Name",
	group_name: "Group Name",
	loan_id: "Loan ID",
	debit: "Debit",
	credit: "Credit",
	penal_recov: "Penal",
	requisition_status: "Requisition Status",
	created_by: "Requisition By",
	created_at: "Requisition At",
}

const attendanceReportHeader = {
	entry_dt: "Entry Date",
	branch_id: "Branch ID",
	emp_id: "Employee ID",
	emp_name: "Employee Name",
	phone_mobile: "Phone Number",
	in_date_time: "In Date Time",
	out_date_time: "Out Date Time",
	in_addr: "Clock In Address",
	out_addr: "Clock Out Address",
	clock_status: "Clock Status",
	late_in: "Late In",
	branch_name: "Branch Name"
	// attn_reject_remarks: "Attendance Reject Remarks",
	// attan_status: "Attendance Status",
}

const absenteesReportHeader = {
	emp_id: "Employee ID",
	abs_dt: "Absent Date",
	emp_name: "Employee Name",
	branch_id: "Branch ID",
	branch_name: "Branch Name",
}



const loanStatementHeader = {
	loan_id: "Loan ID",
	member_code: "Member Code",
	group_code: "Group Code",
	branch_code: 'Branch Code',
	client_name: "Client Name",
	trans_date: "Transaction Date",
	trans_no: "Transaction No",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principal Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	balance: "Balance",
	curr_balance: "Current Balance",
	intt_balance: "Interest Balance",
	total_outstanding: "Total Outstanding",
	tr_type: "Transaction Type",
	tr_mode: "Transaction Mode",
	particulars: "Particulars",
	created_by: "Created By",
	created_at: "Created At",
	approved_by: "Approved By",
	approved_at: "Approved At",
	STATUS: "Status",
}

const loanStatementHeader_New = {
	loan_id: "Loan ID",
	member_code: "Member Code",
	group_code: "Group Code",
	branch_code: 'Branch Code',
	client_name: "Client Name",
	trans_date: "Transaction Date",
	trans_no: "Transaction No",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principal Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	balance: "Balance",
	curr_balance: "Current Balance",
	intt_balance: "Interest Balance",
	total_outstanding: "Total Outstanding",
	tr_type: "Transaction Type",
	tr_mode: "Transaction Mode",
	particulars: "Particulars",
	co_id: "CO ID",
	co_name: "CO Name",
	created_by: "Created By",
	created_at: "Created At",
	approved_by: "Approved By",
	approved_at: "Approved At",
	STATUS: "Status",
}

const loanStatementHeaderGroupwise = {
	loan_id: "Loan ID",
	member_code: "Member Code",
	group_code: "Group Code",
	branch_code: 'Branch Code',
	client_name: "Client Name",
	trans_date: "Transaction Date",
	trans_no: "Transaction No",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principal Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	balance: "Balance",
	curr_balance: "Current Balance",
	intt_balance: "Interest Balance",
	total_outstanding: "Total Outstanding",
	tr_type: "Transaction Type",
	tr_mode: "Transaction Mode",
	particulars: "Particulars",
	created_by: "Created By",
	created_at: "Created At",
	approved_by: "Approved By",
	approved_at: "Approved At",
	STATUS: "Status",
}

const loanStatementHeaderGroupwise_New = {
	loan_id: "Loan ID",
	member_code: "Member Code",
	group_code: "Group Code",
	branch_code: 'Branch Code',
	client_name: "Client Name",
	trans_date: "Transaction Date",
	trans_no: "Transaction No",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principal Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	balance: "Balance",
	curr_balance: "Current Balance",
	intt_balance: "Interest Balance",
	total_outstanding: "Total Outstanding",
	tr_type: "Transaction Type",
	tr_mode: "Transaction Mode",
	particulars: "Particulars",
	co_id: "CO ID",
	co_name: "CO Name",
	created_by: "Created By",
	created_at: "Created At",
	approved_by: "Approved By",
	approved_at: "Approved At",
	STATUS: "Status",
}

const txnGrpHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	payment_date: "Payment Date",
	group_code: "Group Code",
	group_name: "Group Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	co_name: "CO Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	bank_name: "Bank",
	bank_branch_name: "Bank Branch",
}

const txnGrpHeaderForPreviousLoanTrxns = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	payment_date: "Payment Date",
	area_code: "Division Name",
	group_code: "Group Code",
	group_name: "Group Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	emp_name: "CO Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	bank_name: "Bank",
	bank_branch_name: "Bank Branch",
	tr_mode: "TR Mode",
}

const txnFundHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	payment_date: "Payment Date",
	group_code: "Group Code",
	group_name: "Group Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	co_name: "CO Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	bank_name: "Bank",
	bank_branch_name: "Bank Branch",
}

const txnFundHeaderforPreviousLoanTrxns = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	payment_date: "Payment Date",
	group_code: "Group Code",
	group_name: "Group Name",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	sb_account: "Savings Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	emp_name: "CO Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	bank_name: "Bank",
	bank_branch_name: "Bank Branch",
	tr_mode: "TR Mode",
}

const txnCoHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	payment_date: "Payment Date",
	co_id: "CO ID",
	co_name: "CO Name",
	total_group: "Total Group",
	total_member: "Total Member",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
}

const txnCoHeaderForPreviousLoanTrxns = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	payment_date: "Payment Date",
	co_id: "CO ID",
	emp_name: "CO Name",
	group_code: 'Group Code',
	group_name: "Group Name",

	bank_name: "Bank Name",
	sb_account: "SB Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	total_group: "Total Group",
	total_member: "Total Member",
	fund_id: "Fund ID",
	fund_name: "Fund Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "principle Recovery",
	intt: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	tr_mode: "TR Mode",
}

const txnMembHeader = {
	payment_date: "Payment Date",
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	loan_id: "Loan ID",
	member_code: "Member Code",
	client_name: "Client Name",
	group_code: "Group Code",
	group_name: "Group Name",
	sb_account: "SB Account",
	loan_account: "Loan Account",
	grp_addr: "Group Address",
	co_id: "CO ID",
	emp_name: "CO Name",
	scheme_id: "Scheme ID",
	scheme_name: "Scheme Name",
	debit: "Debit",
	credit: "Credit",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
	curr_balance: "Current Balance",
	bank_name: "Bank",
	bank_branch_name: "Bank Branch",
	created_code: "Created Code",
	created_at: "Created At",
	created_by: "Created By",
	approved_code: "Approved Code",
	approved_by: "Approved By",
	approved_at: "Approved At",
	tr_mode: "TR Mode",
}

const branchwiseTxnReportHeader = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	area_code: "Division Name",
	debit: "Debit",
	credit: "Credit",
	curr_balance: "Current Balance",
	prn_recov: "Principle Recovery",
	intt_recov: "Interest Recovery",
	penal_recov: "Penal Recovery",
	penal_amount: "Penal Amount",
	penal_intt: "Penal Amount",
}

const overdueVisitHeader = {
	group_code: "Group Code",
	group_name: "Group Name",
	member_name: "Member Name",
	member_code: "Member Code",
	// branch_id: "Branch ID",
	// branch_name: "Branch Name",
}

const overdueVisitHeaderReport = {
	group_code: "Group Code",
	group_name: "Group Name",
	member_name: "Member Name",
	co_id: "CO ID",
	co_name: "CO Name",
	action: "Action"
}

const overdueVisitHeaderReport_ALL = {
	branch_code: "Branch Code",
	branch_name: "Branch Name",
	division: "Division",
	group_code: "Group Code",
	group_name: "Group Name",
	co_id: "CO ID",
	co_name: "CO Name",
	member_code: "Member Code",
	member_name: "Member Name",
	loan_id: "Loan ID",
	datetime_visit: "Visit Date & Time",
	client_mobile: "Mobile",
	client_addr: "Address",
	promise_date: "Promise Date",
	promise_amt: "Promise Amount",
	remarks: "Remarks",
	admin_remarks: "Admin Remarks",
	paid_amount: "Paid Amount",
	payment_status: "Payment Status",
	scheme_name: "Scheme Name",
	disb_dt: "Disbursement Date",
	tot_emi: "EMI Amount",
	member_disb_amount: "Member Disbursement",
	group_disb_amount: "Group Disbursement",
	overdue_date: "Overdue Date",
	member_overdue_amount: "Member Overdue",
	member_outstanding: "Member Outstanding",
	group_overdue_amount: "Group Overdue",
	group_outstanding: "Group Outstanding",
};


const txnDetailsHeader = {
	payment_date: "Payment Date",
	payment_id: "Payment ID",
	particulars: "Particulars",
	credit: "Credit",
	penal_recov: "Penal Amount",
	debit: "Debit",
	prn_bal: "Principal Balance",
	intt_balance: "Interest Balance",
	outstanding: "Outstanding",
	tr_type: "Transaction Type",
	tr_mode: "Transaction Mode",
	status: "Status",
	approve_details: "Approve Details"
}

const portfolioReportHeaderGroupwise = {
	from_dt: "From Date",
	to_dt: "To Date",
	branch_cd: "Branch Code",
	division: "Division Name",
	scheme_name: "Scheme Name",
	cust_type: "Customer Type",
	group_cd: "Group Code",
	group_name: "Group Name",
	sb_ac_no: "SB Account Number",
	loan_ac_no: "Loan Account Number",
	bank_name: "Bank Name",
	applied_dt: "Application Date",
	applied_amt: "Applied Amount",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	proc_charge: "Processing Charge",
	service_charge: "Service Charge",
	intt_rt: "Interest Rate",
	tot_emi: "Total EMI",
	fund_name: "Fund Name",
	purpose_id: "Purpose ID",
	co_id: "CO ID",
	co_name: "CO Name",
	demand: "Demand",
	open_bal: "Opening Balance",
	Disbursement_in_the_period: "Disbursement in Period",
	prn_recov: "Principal Recovered",
	intt_recov: "Interest Recovered",
	Recovery_in_the_period: "Recovery in Period",
	prn_amt: "Principal Amount",
	intt_amt: "Interest Amount",
	Outstanding: "Outstanding",
	overdue_amt: "Overdue Amount",
	penal_amount: "Penal Amount",
	total: "Total",
	First_overdue_date: "First Overdue Date",
	Overdue_transfer_date: "Overdue Transfer Date",
	Loan_end_date: "Loan End Date",
	// Last_transaction_date: "Last Transaction Date",
}

const portfolioReportHeaderMemberwise = {
	from_dt: "From Date",
	to_dt: "To Date",
	branch_cd: "Branch Code",
	division: "Division Name",
	form_no: "Form Number",
	loan_id: "Loan ID",
	scheme_name: "Scheme Name",
	cust_type: "Customer Type",
	group_cd: "Group Code",
	group_name: "Group Name",
	memb_id: "Member ID",
	client_name: "Client Name",
	client_mobile: "Client Mobile",
	gurd_name: "Guarantor Name",
	dob: "Date of Birth",
	religion: "Religion",
	caste: "Caste",
	husband_name: "Husband's Name",
	Address: "Address",
	aadhar_no: "Aadhar Number",
	pan_no: "PAN Number",
	voter_id: "Voter ID",
	sb_ac_no: "SB Account Number",
	loan_ac_no: "Loan Account Number",
	bank_name: "Bank Name",
	applied_dt: "Application Date",
	applied_amt: "Applied Amount",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	proc_charge: "Processing Charge",
	service_charge: "Service Charge",
	intt_rt: "Interest Rate",
	tot_emi: "Total EMI",
	fund_name: "Fund Name",
	purpose_id: "Purpose ID",
	co_id: "CO ID",
	co_name: "CO Name",
	demand: "Demand",
	open_bal: "Opening Balance",
	Disbursement_within_the_period: "Disbursement Within Period",
	prn_recov: "Principal Recovered",
	intt_recov: "Interest Recovered",
	Recovery_within_the_period: "Recovery Within Period",
	prn_amt: "Principal Amount",
	intt_amt: "Interest Amount",
	Outstanding: "Outstanding",
	overdue_amt: "Overdue Amount",
	penal_amount: "Penal Amount",
	total: "Total",
	First_overdue_date: "First Overdue Date",
	Overdue_transfer_date: "Overdue Transfer Date",
	Loan_end_date: "Loan End Date",
	Last_tranaction_date: "Last Transaction Date",
}

const portfolioReportHeaderFundwise = {
	from_dt: "From Date",
	to_dt: "To Date",
	branch_cd: "Branch Code",
	division: "Division Name",
	cust_type: "Customer Type",
	group_cd: "Group Code",
	group_name: "Group Name",
	applied_dt: "Application Date",
	applied_amt: "Applied Amount",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	intt_rt: "Interest Rate",
	tot_emi: "Total EMI",
	fund_name: "Fund Name",
	co_id: "CO ID",
	co_name: "CO Name",
	demand: "Demand",
	open_bal: "Opening Balance",
	Disbursement_within_the_period: "Disbursement Within Period",
	Recovery_within_the_period: "Recovery Within Period",
	prn_amt: "Principal Amount",
	intt_amt: "Interest Amount",
	Outstanding: "Outstanding",
	overdue_amt: "Overdue Amount",
	penal_amount: "Penal Amount",
	total: "Total",
	First_overdue_date: "First Overdue Date",
	Overdue_transfer_date: "Overdue Transfer Date",
	Loan_end_date: "Loan End Date",
	Last_tranaction_date: "Last Transaction Date",
}

const portfolioReportHeaderCOwise = {
	from_dt: "From Date",
	to_dt: "To Date",
	branch_cd: "Branch Code",
	division: "Division Name",
	cust_type: "Customer Type",
	group_cd: "Group Code",
	group_name: "Group Name",
	applied_dt: "Application Date",
	applied_amt: "Applied Amount",
	disb_dt: "Disbursement Date",
	disb_amt: "Disbursement Amount",
	intt_rt: "Interest Rate",
	tot_emi: "Total EMI",
	co_id: "CO ID",
	co_name: "CO Name",
	demand: "Demand",
	open_bal: "Opening Balance",
	Disbursement_within_the_period: "Disbursement Within Period",
	Recovery_within_the_period: "Recovery Within Period",
	prn_amt: "Principal Amount",
	intt_amt: "Interest Amount",
	Outstanding: "Outstanding",
	overdue_amt: "Overdue Amount",
	penal_amount: "Penal Amount",
	total: "Total",
	First_overdue_date: "First Overdue Date",
	Overdue_transfer_date: "Overdue Transfer Date",
	Loan_end_date: "Loan End Date",
	Last_tranaction_date: "Last Transaction Date",
}

const portfolioReportHeaderBranchwise = {
	from_dt: "From Date",
	to_dt: "To Date",
	branch_cd: "Branch Code",
	area_code: "Division Name",
	branch_name: "Branch Name",
	cust_type: "Customer Type",
	group_cd: "Group Code",
	group_name: "Group Name",
	disb_amt: "Disbursement Amount",
	demand: "Demand",
	open_bal: "Opening Balance",
	Disbursement_within_the_period: "Disbursement Within Period",
	Recovery_within_the_period: "Recovery Within Period",
	prn_amt: "Principal Amount",
	intt_amt: "Interest Amount",
	Outstanding: "Outstanding",
	overdue_amt: "Overdue Amount",
	penal_amount: "Penal Amount",
	total: "Total",
}

const grtHeader = {
	form_no: 'Form Number',
	prov_grp_code: 'Group Code',
	group_name: 'Group Name',
	branch_name: "Branch",
	member_code: 'Member Code',
	client_name: "Member Name",
	grt_date: "GRT Date",
	dob: "Date Of Birth",
	gender: "Gender",
	client_addr: "Member Address",
	pin_no: "PIN",
	client_mobile: "Member Mobile Number",
	email_id: "Member Email",
	gurd_name: "Father Name",
	gurd_mobile: "Husband Mobile Number",
	husband_name: "Husband Name",
	aadhar_no: "Aadhar No",
	pan_no: "Pan No",
	voter_id: "Voter ID",
	religion: "Religion",
	caste: "Caste",
	education: "Education",
	self_occu: "Self Occupation",
	self_income: "Monthly Income",
	spouse_occu: "Spouse Occupation",
	spouse_income: "Spouse Monthly Income",
	loan_purpose: "Purpose Of Loan",
	applied_amt: "Amount Applied",
	other_loan_flag: 'Other Loans',
	other_loan_amt: 'Other Loan Amount',
	other_loan_emi: 'Other Loan EMI',
	parental_addr: 'Parental Address',
	house_type: "House Type",
	own_rent: "Own Or Rent",
	land: "Total Land",
	poltical_flag: "Politically Active",
	tv_flag: "Own A TV",
	bike_flag: "Own A Bike",
	fridge_flag: "Own A Fridge",
	wm_flag: "Own a Washing Machine",
	remarks: "Remarks"
}

export {
	fundwiseOutstandingHeader,
	cowiseOutstandingHeader,
	groupwiseOutstandingHeader,
	memberwiseOutstandingHeader,
	disbursementDetailsHeader,
	branchwiseOutstandingHeader,
	branchwiseTxnReportHeader,
	groupwiseDemandReportHeader,
	fundwiseDemandReportHeader,
	cowiseDemandReportHeader,
	memberwiseDemandReportHeader,
	branchwiseDemandReportHeader,
	overdueGroupReportHeader,
	overdueFundReportHeader,
	overdueCOReportHeader,
	overdueMemberReportHeader,
	overdueBranchReportHeader,
	transactionFieldNames,
	attendanceReportHeader,
	absenteesReportHeader,
	overdueVisitHeader,
	rejectTransFieldNames,
	loanStatementHeader,
	loanStatementHeader_New,
	loanStatementHeaderGroupwise,
	loanStatementHeaderGroupwise_New,
	txnGrpHeader,
	txnFundHeader,
	txnCoHeader,
	txnMembHeader,
	groupwiseDemandVsCollectionHeader,
	groupwiseDemandVsCollectionHeader_New,
	cowiseDemandVsCollectionHeader,
	memberwiseDemandVsCollectionHeader,
	branchwiseDemandVsCollectionHeader,
	fundwiseDemandVsCollectionHeader,
	txnDetailsHeader,
	portfolioReportHeaderGroupwise,
	portfolioReportHeaderMemberwise,
	portfolioReportHeaderFundwise,
	portfolioReportHeaderCOwise,
	portfolioReportHeaderBranchwise,
	grtHeader,
	groupReportGroupWiseHeader,
	groupReportGroupWiseHeader_No_CloseDate,
	memberwiseReportHeader,
	memberwiseReportHeader_No_CloseDate,
	txnGrpHeaderForPreviousLoanTrxns,
	txnFundHeaderforPreviousLoanTrxns,
	txnCoHeaderForPreviousLoanTrxns,
	Receipt_Summary_Report_Group,
	Receipt_Summary_Report_CO,
	Receipt_Summary_Report_Group_Branch,
	Receipt_Summary_Report_CO_Branch,
	COwise_Collection_Summary_Report,
    COwise_Collection_Summary_Report_HO,
	overdueVisitHeaderReport,
	overdueVisitHeaderReport_ALL,
	requestedRequisitionHeader,
	searchRejectTransFieldNames
}
